import { render } from "./InputEntityLevel.vue?vue&type=template&id=e0863646"
import script from "./InputEntityLevel.vue?vue&type=script&lang=js"
export * from "./InputEntityLevel.vue?vue&type=script&lang=js"
script.render = render

export default script